import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';

import {MatIconModule} from '@angular/material/icon';

@Component({
  selector: 'app-branding',
  standalone: true,
    imports: [RouterModule, MatIconModule],
  template: `
    <div class="branding">
      <img src="/assets/images/logos/shine.svg" class="logo" alt="Shine logo"/>
    </div>
  `,
  styles: [`
    .logo {
      max-height: 40px;
      margin: 8px;
    }
  `]
})
export class BrandingComponent {
  constructor() {
  }
}
